import { useParams } from "react-router-dom";
import CustomForm from '../../../core/components/core/Util/Form/CustomForm/CustomForm';
import CustomFormContainer from '../../../core/components/core/Util/Form/CustomForm/CustomFormContainer';
import config from '../../config/config';
import Fetch from '../../../core/util/core/Fetch';
import { useEffect,useState } from 'react';
import { chooseProfileFilter } from "../../helpers/chooseProfileFilter";

function Form() {
    const profileFilter = chooseProfileFilter();
    const { id } = useParams();
    const [form,setForm] = useState();
    const [formContent,setFormContent] = useState(<>Carregando...</>);

    const endpointBackend = config.endpoints.backend;
    const path = 'governanceroom/sectors';

    const paths = {
        endpointSave: `${endpointBackend}governanceroom/sectors/save`,
        endpointGetById: `${endpointBackend}${path}/getById`,
        urlGoBack: `/governanceroom/sectors/list`,
        pathView: `/governanceroom/sectors/view`
    }

    const labels = {
        labelTitleAdd: "Novo Setor",
        labelTitleEdit: "Editar Setor",
        labelTitleView: 'Visualizar Setor'
    }

    const hiddenValues = {}

    if (profileFilter.core_application_instance_id) {
        hiddenValues.core_application_instance_id = profileFilter.core_application_instance_id
    }

    const getForm = (values) => {

        let form = {
            hiddenValues: hiddenValues,
            fields: [
                {
                    name: 'governance_room_neighborhood_id',
                    type: 'select',
                    label: 'Bairro',
                    options: [],
                    optionsEndpoint: {
                        endpoint: endpointBackend + 'governanceroom/neighborhoods/getall',
                        label: 'description',
                        value: 'id',
                        params: {
                            filter: {
                                profileFilter
                            }
                        }
                    },
                    validations: {
                        required: true
                    },
                    columnSize: 12
                },
                {
                    name: 'sector_id',
                    type: 'text',
                    label: 'Setor',
                    validations: {
                      required: false
                    },
                    columnSize: 12,
                    readOnly: true
                },
                {
                    name: 'type_id',
                    type: 'text',
                    label: 'Tipo',
                    validations: {
                      required: false
                    },
                    columnSize: 12,
                    readOnly: true
                },
                {
                    name: 'area_km2',
                    type: 'text',
                    label: 'Area Km²',
                    validations: {
                      required: false
                    },
                    columnSize: 12,
                    readOnly: true
                },
                {
                    name: 'situation',
                    type: 'text',
                    label: 'Situação',
                    validations: {
                      required: false
                    },
                    columnSize: 12,
                    readOnly: true
                }
            ],
            ...paths,
            ...labels,
        }
        form.values = values;
        return form;
    }

    useEffect(() => {
        const load = async () => {
            let values = {};
            let cityId = '';
            if (id) {
                values = await Fetch.post(paths.endpointGetById,{id:id})
                cityId = values.city_id;
            }
            if(profileFilter.core_application_instance_id){
                values.core_application_instance_id = profileFilter.core_application_instance_id;
            }
            const form = getForm(values);

            if(!!cityId){
                const index = form.fields.findIndex(item => item.name = 'governance_room_neighborhood_id');
                form.fields[index].optionsEndpoint.params.filter = {
                    ...form.fields[index].optionsEndpoint.params.filter,
                    city_id: cityId
                }
            }

            setForm(form);
            setFormContent(
                <CustomFormContainer
                    form={form}
                    content={<CustomForm form={form} />} />
            );
        }
        load();
    },[])

    return (
        <div>
            {formContent}
        </div>
    );
}
export default Form;
